import { chatbotCalcFormSlides } from "./step-form";

document.addEventListener("DOMContentLoaded", async () => {
	chatbotCalcFormSlides();
});
